module.exports = __webpack_public_path__ + "static/media/Promotionaltooltipimage.59091ce7.png";